import React from "react";
import { Box } from "@mui/material";
import { SimpleBlankSlate } from "../../core/components/SimpleBlankSlate";
import { VCard } from "../layout/Card/VCard";
import noSessionsImg from "../../img/no-sessions.svg";
import { PrimaryButton } from "../layout/Button/Button";
import { useAppNavigate } from "../../hooks/useAppNavigate";
import { useAuth } from "../../contexts/auth.context";

interface ProgrammesBlankSlateProps {
    title: string;
    description: string;
}

export const ProgrammesBlankSlate = ({ title, description }: ProgrammesBlankSlateProps): JSX.Element => {
    const { push } = useAppNavigate();
    const { hasPermission } = useAuth();

    return (
        <Box m="auto" p={4} display="flex" justifyContent="center" alignItems="center" minHeight="70vh">
            <VCard
                style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    maxWidth: "600px",
                    padding: "2.5rem",
                    borderRadius: "16px",
                    boxShadow: "0px 8px 30px rgba(0, 0, 0, 0.05)",
                }}
            >
                <SimpleBlankSlate
                    header={title}
                    image={
                        <img
                            src={noSessionsImg}
                            alt="No Programmes"
                            style={{
                                width: "140px",
                                height: "140px",
                                marginBottom: "1.5rem",
                                filter: "drop-shadow(0px 4px 20px rgba(0, 0, 0, 0.08))",
                            }}
                        />
                    }
                    subHeader={description}
                    actions={
                        hasPermission("ProgrammeCreate") ? (
                            <Box mt={4} display="flex" justifyContent="center">
                                <PrimaryButton
                                    onClick={() => push("/programmes/add")}
                                    style={{
                                        padding: "0.75rem 2rem",
                                        fontSize: "1rem",
                                        fontWeight: 600,
                                        borderRadius: "8px",
                                        transition: "transform 0.2s ease-in-out",
                                    }}
                                >
                                    Create a Programme
                                </PrimaryButton>
                            </Box>
                        ) : undefined
                    }
                />
            </VCard>
        </Box>
    );
};
